








































































































import { Component } from 'vue-property-decorator';
import CategoryPreviewComponent from '@/enroll/components/link-generator/category-preview.component.vue';
import ProductPreviewComponent from '@/enroll/components/link-generator/product-preview.component.vue';
import LinkPreviewComponent from '@/enroll/components/link-generator/link-preview.component.vue';
import StoreLinkComponent from '@/enroll/components/link-generator/store-link.component.vue';
import SpinButton from '@/enroll/components/link-generator/spin-button.component.vue';
import Category from '@/enroll/entities/link-generator/category.entity';
import Product from '@/enroll/entities/link-generator/product.entity';
import Currency from '@/_shared/entities/currency.entity';
import EnrollmentLinkComponent from '@/enroll/components/link-generator/enrollment-link.component.vue';
import Pack from '@/enroll/entities/link-generator/pack.entity';
import PacksPreview from '@/enroll/components/link-generator/packs-preview.component.vue';
import BreadcrumbComponent from '@/_shared/components/layout/breadcrumb.component.vue';
import LinkGeneratorTranslateMixin from '@/enroll/mixins/link-generator/translate.mixin';
import Country from '@/enroll/entities/link-generator/country.entity';
import publicToolsService from '@/enroll/services/link-generator/public-tools.service';
import startCase from 'lodash/startCase';

@Component({
  components: {
    BreadcrumbComponent,
    EnrollmentLinkComponent,
    StoreLinkComponent,
    CategoryPreviewComponent,
    ProductPreviewComponent,
    LinkPreviewComponent,
    SpinButton,
    PacksPreview,
  },
})
export default class LinkGeneratorView extends LinkGeneratorTranslateMixin {
  public activeView = 'form';

  private tabIndex = 0;

  private packs: Pack[] = [];

  private countries: Country[] = [];

  private packsCurrency: Currency | null = null;

  private loadingPacks = false;

  get isFormActive(): boolean {
    return this.activeView === 'form';
  }

  get isPreviewActive(): boolean {
    return this.activeView === 'preview';
  }

  get activeTabTitle(): string {
    if (this.tabIndex === 0) {
      return this.storeLinkTabTitle;
    }

    return this.enrollmentLinkTabTitle;
  }

  get storeLinkTabTitle(): string {
    return this.i18n.t('LINK_GENERATOR.SHOPPING_CART_TITLE').toString();
  }

  get enrollmentLinkTabTitle(): string {
    return this.i18n.t('LINK_GENERATOR.ENROLLMENT_TITLE').toString();
  }

  get category(): Category | null {
    return this.$store.state.LinkStore.category;
  }

  get product(): Product | null {
    return this.$store.state.LinkStore.product;
  }

  get currency(): Currency | null {
    return this.$store.state.LinkStore.currency;
  }

  get showPacksPreview(): boolean {
    const isEnrollment = this.tabIndex === 1;
    return isEnrollment && !!this.packs?.length;
  }

  get showDefaultPreview(): boolean {
    const isEnrollment = this.tabIndex === 1;
    return (!isEnrollment && this.category === null && this.product === null)
      || (isEnrollment && !this.packs?.length);
  }

  get showCategoryPreview(): boolean {
    const isEnrollment = this.tabIndex === 1;
    return this.category !== null && !isEnrollment;
  }

  get showProductPreview(): boolean {
    const isEnrollment = this.tabIndex === 1;
    return this.product !== null && !isEnrollment;
  }

  public switchView(view: string): void {
    this.activeView = view;
  }

  private changeTag(tabIndex: number): void {
    this.tabIndex = tabIndex;
  }

  async retrieveCountries(): Promise<void> {
    await publicToolsService.getCountries()
      .then(this.setMappedCountries);
  }

  setMappedCountries(countries: Country[]): void {
    this.countries = countries
      .map((country) => ({
        ...country,
        text: startCase(this.i18n.t(country.textKey).toString().toLowerCase()),
      }));
  }

  created() {
    this.retrieveCountries();
  }
}
